import { combineReducers } from 'redux';
import { CONFIRM_COUNTRIES_FAILED, COUNTRIES_CONFIRMED, FETCHING_COUNTRIES, GET_COUNTRIES, GET_COUNTRIES_FAILED } from '../actions/countries';
import { ConfirmCountryResponseType } from '../generated-types';
const initialState = {
  countries: [],
  fetchingCountries: false,
  failedOnFetch: false
};
const fetch = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case GET_COUNTRIES:
      return {
        countries: action.countries,
        fetchingCountries: false,
        failedOnFetch: false
      };
    case FETCHING_COUNTRIES:
      return {
        countries: [],
        fetchingCountries: true,
        failedOnFetch: false
      };
    case GET_COUNTRIES_FAILED:
      return {
        countries: [],
        fetchingCountries: false,
        failedOnFetch: true
      };
    default:
      return state;
  }
};
const initialConfirmState = {
  loaded: false
};
const confirmCountries = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialConfirmState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case COUNTRIES_CONFIRMED:
      return {
        response: action.response,
        loaded: true,
        failedOnConfirm: false
      };
    case CONFIRM_COUNTRIES_FAILED:
      return {
        response: {
          typeInfo: ConfirmCountryResponseType.ERROR
        },
        loaded: true,
        failedOnConfirm: true
      };
    default:
      return state;
  }
};
export default combineReducers({
  fetch,
  confirmCountries
});